
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/events",
      function () {
        return require("private-next-pages/next/events/index.tsx");
      }
    ]);
  